<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<template>
  <nav
    ref="flyoutNav"
    tabindex="-1"
    :aria-label="selectedLanguage.details.label"
    :style="styles"
    @mouseleave="closeOptions"
    @focusin="onFocusIn"
    @focusout="onFocusOut"
  >
    <button
      aria-haspopup="listbox"
      class="navigation-flyout-trigger"
      :class="{ '-is-open': isOpen }"
      data-testid="navigation-language-menu-desktop"
      @mouseover="showOptions"
      @focus="onButtonFocus"
    >
      <span>{{ selectedLanguage.details.label }}</span>
      <Icon
        icon="fa6-solid:chevron-down"
        data-icon="fa6-solid:chevron-down"
        width="10"
        height="10"
      />
    </button>
    <ul
      v-show="isOpen"
      ref="options"
      tabindex="-1"
      class="navigation-flyout-options"
      role="listbox"
    >
      <li
        v-for="(language, index) in languages"
        :key="language.details.locale"
        :aria-selected="language === selectedLanguage"
        @click="selectLanguage(language)"
        @keydown.down.prevent="focusNextItem(index)"
        @keydown.up.prevent="focusPrevItem(index)"
        @keydown.esc.prevent="close"
      >
        <a
          class="navigation-flyout-option"
          :href="language.url"
          data-testid="navigation-language-desktop"
          @click="$emit('emittedClick', { type: 'language', el: language })"
        >
          <span>{{ language.details.label }}</span>
          <Icon
            icon="fa6-solid:arrow-right"
            data-icon="fa6-solid:arrow-right"
            width="12"
            height="12"
          />
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import navigationDefaultGlobalProps from "../navigationDefaultGlobalProps.js";
import { Icon } from "@iconify/vue";
import { flyoutMixins } from "./flyoutMixins.js";

export default {
  name: "NavigationUILanguageFlyout",
  components: {
    Icon,
  },
  mixins: [flyoutMixins],
  props: {
    languages: {
      type: Array,
      required: true,
      default: () => navigationDefaultGlobalProps.config.general.languages,
    },
    pageLocale: {
      type: String,
      default: "",
    },
  },
  emits: ["emittedClick"],
  data() {
    return {
      isOpen: false,
      selectedLanguage: {},
    };
  },
  created() {
    // preselect the selectedLanguage based on the language locale of the page
    // only if pageLocale is set && language equal to it is present
    if (
      this.pageLocale &&
      this.languages.some(
        (language) => language.details.locale === this.pageLocale,
      )
    ) {
      this.selectedLanguage = this.languages.find(
        (language) => language.details.locale === this.pageLocale,
      );
    } else {
      this.selectedLanguage = this.languages[0];
    }
  },
  methods: {
    selectLanguage(language) {
      this.selectedLanguage = language;
      this.isOpen = false;
    },
    focusNextItem(currentIndex) {
      if (currentIndex < this.languages.length - 1) {
        this.$refs.options.querySelectorAll("a")[currentIndex + 1].focus();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./flyout.scss";
</style>
